module.exports = __webpack_public_path__ + "img/system.ff225c97.png";